/**
 *
 * ServicesCTA
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import { Row, Col } from 'react-bootstrap';
import FeatureWithIcon from '../FeatureWithIcon';
import { SDescription, SH1, SH2 } from './styles';
import { BiCheckDouble } from '@react-icons/all-files/bi/BiCheckDouble';
import { SpacedTitle } from 'components/Layout/styles';

export const ServicesCTA = ({
  type,
  title,
  isHeading1,
  description,
  featuresList = [],
  onClick,
  ctaText = 'Learn More',
  actionChildren,
  titleChildren,
  mode,
  padding_bottom,
  displayFeatures,
  id,
}) => {
  const centerScreenType =
    type === 'cards_grid' ? 'text-lg-start ps-xl-5' : 'text-md-start';

  return (
    <div
      id={id}
      className={`mx-3 mx-md-0 text-sm-center ${centerScreenType} `}
      style={{ paddingBottom: padding_bottom && padding_bottom }}
    >
      {displayFeatures && (
        <SpacedTitle colorVariant="accentDark"> FEATURES </SpacedTitle>
      )}
      {titleChildren}
      {title && isHeading1 && <SH1 className="my-3 mt-md-0">{title}</SH1>}
      {title && !isHeading1 && <SH2 className="my-3 mt-md-0">{title}</SH2>}
      {description && <SDescription mode={mode}>{description}</SDescription>}
      {featuresList && (
        <Row>
          {featuresList.map((f, i) => {
            return (
              <Col key={i} xs="12" md="6">
                <FeatureWithIcon
                  // iconVariant="success"
                  withBackground={false}
                  isIconSVG={false}
                  text={f}
                  icon={<BiCheckDouble className="me-2" />}
                />
              </Col>
            );
          })}
        </Row>
      )}
      {actionChildren}
      {onClick && <Button onClick={onClick}>{ctaText}</Button>}
    </div>
  );
};

ServicesCTA.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  featuresList: PropTypes.array,
  ctaText: PropTypes.string,
  isHeading1: PropTypes.bool,
  actionChildren: PropTypes.element,
  titleChildren: PropTypes.element,
  padding_bottom: PropTypes.number,
  mode: PropTypes.string,
  type: PropTypes.string,
  displayFeatures: PropTypes.bool,
  customColorDescription: PropTypes.string,
  id: PropTypes.string,
};

export default ServicesCTA;
